export default __webpack_public_path__ + "static/media/tuteeline.51b84327.png";